import React from 'react';
import { ClipboardListIcon, ClockIcon, HelpCircleIcon, LayersIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { problems } from '../data/content';
const ICONS = {
  layers: LayersIcon,
  help: HelpCircleIcon,
  clipboard: ClipboardListIcon,
  clock: ClockIcon
};
export function ProblemSection() {
  return <section aria-labelledby="problema" className="bg-brand-mist text-brand-ink" data-id="element-141" data-mp="2vp6cwdfhom9a">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-142" data-mp="39gkvij5hilft">
        <p className="inline-block rounded-md bg-brand-red px-2 py-0.5 text-xs font-semibold uppercase tracking-widest text-white" data-id="element-143" data-mp="35gu207okpr7l">
          ¿Te suena familiar?
        </p>
        <h2 id="problema" className="mt-2 font-display text-2xl font-bold leading-tight text-brand-blue sm:text-3xl" data-id="element-144" data-mp="3egz545mqi3fy">
          Querés preparar clases de inglés atractivas y organizadas,{' '}
          <span className="bg-brand-yellow px-1 text-brand-ink" data-id="element-145" data-mp="1k3hdo7j7kmfn">
            pero terminás buscando actividades, ejercicios y evaluaciones en
            diferentes páginas.
          </span>
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-brand-muted" data-id="element-146" data-mp="obexeyq8am9n">
          Si enseñás inglés en primaria o estás comenzando a preparar tus
          clases, probablemente conozcas alguna de estas situaciones:
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-147" data-mp="x5t9ksfgpgoj">
          {problems.map((problem, i) => {
          const Icon = ICONS[problem.icon];
          return <Reveal key={problem.title} as="li" delay={i * 0.03} className="flex h-full gap-2.5 rounded-xl border-l-4 border-brand-red bg-white p-2.5 text-left" data-id="element-148" data-mp="171mvv3izgoji" data-mpi={i}>
                <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-lg bg-brand-red/10" data-id="element-149" data-mp="1g19vbjs5jk9x">
                  <Icon size={15} className="text-brand-red" data-id="element-150" data-mp="3hur5au3r8x7u" />
                </span>
                <div data-id="element-151" data-mp="3hwkbk8aghffb">
                  <h3 className="text-sm font-bold uppercase leading-tight" data-id="element-152" data-mp="p00l9rbcxozn">
                    {problem.title}
                  </h3>
                  <p className="mt-0.5 text-xs leading-snug text-brand-muted sm:text-sm" data-id="element-153" data-mp="k2h8kvub5k9t">
                    {problem.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}